import { render, staticRenderFns } from "./EditDestination.vue?vue&type=template&id=965948fc"
import script from "./EditDestination.vue?vue&type=script&lang=js"
export * from "./EditDestination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports